module.exports = __webpack_public_path__ + "static/media/taramas-skordopsomo.ccde0f86.jpg";